import React, { useState } from "react";
import { Search } from "lucide-react";

const SearchBar = ({ placeholder = "Search..." }) => {
  const [q, setQ] = useState("");

  return (
    <div className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-lg px-3 py-2 w-full md:w-96">
      <Search className="w-4 h-4 text-gray-500 mr-2" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        className="bg-transparent outline-none text-sm text-gray-700 dark:text-gray-200 w-full"
      />
    </div>
  );
};

export default SearchBar;
